import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';
import {
  CreateFormTemplateKeyDto,
  CreateFormTemplateKeyResponse,
} from './types';

/**
 * Create a new form template key
 */
export async function createFormTemplateKey(
  data: CreateFormTemplateKeyDto
): Promise<{ success: boolean; data?: CreateFormTemplateKeyResponse }> {
  try {
    const res = await fetcher(BASE_URL, {
      method: 'POST',
      body: data,
    });

    if (!res.ok) {
      console.error('Failed to create form template key:', await res.text());
      return { success: false };
    }

    const responseData = (await res.json()) as CreateFormTemplateKeyResponse;
    return {
      success: true,
      data: responseData,
    };
  } catch (err) {
    console.error('Error creating form template key:', err);
    return { success: false };
  }
}

